export default __webpack_public_path__ + "static/media/browse.947a23ef.svg";